import { render } from "./ThemeDialog.vue?vue&type=template&id=19027946"
import script from "./ThemeDialog.vue?vue&type=script&lang=js"
export * from "./ThemeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__